/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import parseHtmlContent from "helpers/parseHtmlContent";

import {colors} from "nxtconstants";
import {WealthyEnv} from "helpers";

import {
  SectionTitle,
  container
} from "../common";

const diamondRuppeeIcon = `url(${WealthyEnv.BROKING_CDN_URL}/diamond-ruppee-icon.png)`;

const propTypes = {
  otherCharges: PropTypes.object
};

const OtherCharges = ({
  otherCharges
}) => {
  const loadCharges = (
    otherCharges.map((dataItem, rowIndex) => (
      <DataRow key={rowIndex}>
        <DataItem>
          {parseHtmlContent(dataItem[0])}
        </DataItem>
        <DataItem>
          {parseHtmlContent(dataItem[1])}
        </DataItem>
      </DataRow>
    ))
  );

  return (
    <ChargesWrapper>
      <SectionTitle>
        Other Charges
      </SectionTitle>
      <Table>
        {loadCharges}
      </Table>
    </ChargesWrapper>
  );
};

const ChargesWrapper = styled(container)`
  padding-top: 10rem;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    bottom: -90px;
    right: -100px;
    z-index: -1;
    width: 157px;
    height: 163px;
    background-image: ${diamondRuppeeIcon};
    background-size: contain;
    background-repeat: no-repeat;
  }

  @media (max-width: 1300px) { 
    &::after {
      right: 0;
    }
  }

  @media (max-width: 768px) { 
    padding-top: 5.2rem;
  }
`;

const Table = styled.div`
  border-radius: 1.5rem;
  overflow: hidden;
  margin-top: 4.4rem;
  padding: 1.7rem 3rem;
  border: 2px solid rgba(126, 126, 126, 0.20);
  background: rgba(255, 255, 255, 0.80);
  backdrop-filter: blur(6.5px);

  @media (max-width: 768px) { 
    margin-top: 3.2rem;
    padding: 1rem 2rem;
  }
`;

const DataRow = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  font-size: 2.4rem;
  padding: 2rem 3.2rem;
  border-bottom: 1px solid #ddd;

  &:last-child {
    border: 0;
  }

  h3 {
    font-size: 2rem;
  }

  span {
    color: ${colors.black};
    font-size: 2rem;
    font-weight: bold;
  }

  small {
    font-size: 1.6rem;
  }

  @media (max-width: 768px) { 
    padding: 3rem 1rem;
    font-size: 1.6rem;

    & > div {
      text-align: left;
      width: 50%;
    }

    & > div:nth-child(2) {
      text-align: right;
    }

    small {
      font-size: 1rem;
      line-height: 1.6;
      display: block;
    }
  }

`;

const DataItem = styled.div`
  text-align: right;
`;

OtherCharges.propTypes = propTypes;

export default OtherCharges;
